
    import './styles.scoped.css';
    export default {
  "expand-toggle-icon": "awsui_expand-toggle-icon_1ss49_etwwy_153",
  "expand-toggle-icon-expanded": "awsui_expand-toggle-icon-expanded_1ss49_etwwy_174",
  "expand-toggle": "awsui_expand-toggle_1ss49_etwwy_153"
};
  